import * as qs from "query-string";
import { OnSentryCatchParam } from "utils/sentryEvent";
import Constant from "utils/headFootConstants";
// 拼接 zeus接口必要的参数
const handleQuery = () => {
	const result = `&sid=${Constant.sid}&language=${Constant.language}&currency=${Constant.currency}&country=${Constant.country}`;
	return result;
};

function checkStatus(response: Response): Response {
	if (!response.ok) {
		console.error(response.status, response.statusText);
	}
	return response;
}

const API_UAT = "/litb-header-zeus";
const API_ONLINE = "/litb-header-zeus";

function transformAddress(isOnline: boolean) {
	if (isOnline) {
		return `https://${location.host?.replace(/pre-mpro|pre-pro/, "pro")}${API_ONLINE}`;
	}
	return `https://kdev0-eechic.ezbuy.dev${API_UAT}`;
}
export interface WebapiOptions {
	cookie?: string;
	headers?: { [key: string]: any };
	fetchMethod?: "GET" | "POST";
	isDev?: boolean;
	onSentryCatch?: (props: OnSentryCatchParam) => void;
}
export interface WebapiParmas {
	[key: string]: any;
}
function webapi<T>(
	method: string,
	params: WebapiParmas = {},
	{ fetchMethod = "GET", headers = {}, onSentryCatch }: WebapiOptions = {},
): Promise<T> {
	const isOnline = !Constant.isUat;
	const platform = Constant.platform.toLocaleLowerCase();
	const webapiAddress = transformAddress(isOnline);

	if (Constant.isUat) {
		params = {
			...params,
			isUat: Constant.isUat,
		};
	}
	const addQuery = handleQuery();
	const url = `${webapiAddress}/${platform}/${method}?${qs.stringify(params)}${addQuery}`;
	if (isOnline) {
		headers = {
			...headers,
			host: "api.eechic.com",
		};
	}
	const isPre = window?.location?.hostname?.includes("pre-");
	return fetch(url, {
		mode: "cors",
		method: fetchMethod,
		credentials: Constant.isDev || isPre ? "same-origin" : "include",
		headers,
	})
		.then(checkStatus)
		.then((response) => {
			if (response) {
				return response.json() as Promise<T>;
			}
		})
		.catch((error) => {
			onSentryCatch &&
				onSentryCatch({
					error,
					request: url,
				});
			throw error;
		});
}

export default webapi;
